import { Tab, TabLabel, Tabs } from '@cambridgeassessment/cambridge-ui';
import { Box, Container, Typography } from '@material-ui/core';
import React, { memo, useCallback, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import ChangeEmailForm from '../ChangeEmailForm/ChangeEmailForm';
import ChangePasswordForm from '../ChangePasswordForm/ChangePasswordForm';
import ChangePersonalInfoForm from '../ChangePersonalInfoForm/ChangePersonalInfoForm';
import { usePersonalInfoPageStyles } from './styles';

const PersonalInfoPage: React.FC = () => {
  const [value, setValue] = useState(0);
  const items = ['Personal info', 'Emails', 'Password'];
  const classes = usePersonalInfoPageStyles();

  const handleChange = useCallback((_event, newValue) => {
    setValue(newValue);
  }, []);

  const renderTab = useCallback(() => {
    switch (value) {
      case 1:
        return <ChangeEmailForm />;
      case 2:
        return <ChangePasswordForm />;
      default:
        return <ChangePersonalInfoForm />;
    }
  }, [value]);

  return (
    <Container disableGutters maxWidth="xl">
      <Box mb={4}>
        <Typography variant="h4" className={classes.heading}>
          Personal info
        </Typography>
      </Box>
      <Tabs
        className={classes.tabs}
        value={value}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={handleChange as any}
      >
        {items.map((item) => (
          <Tab
            className={classes.tab}
            data-testid={item}
            label={<TabLabel label={item} />}
            key={item}
            tabIndex={0}
          />
        ))}
      </Tabs>
      <Box mt={4}>{renderTab()}</Box>
    </Container>
  );
};

export default hot(memo(PersonalInfoPage));
